var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPaperclip = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9697 22.75C7.24973 22.75 4.21973 19.72 4.21973 16V10C4.21973 5.73 7.69973 2.25 11.9697 2.25C16.2397 2.25 19.7197 5.73 19.7197 10V15.5C19.7197 17.84 17.8097 19.75 15.4697 19.75C13.1297 19.75 11.2197 17.84 11.2197 15.5V12C11.2197 11.59 11.5597 11.25 11.9697 11.25C12.3797 11.25 12.7197 11.59 12.7197 12V15.5C12.7197 17.02 13.9497 18.25 15.4697 18.25C16.9897 18.25 18.2197 17.02 18.2197 15.5V10C18.2197 6.55 15.4197 3.75 11.9697 3.75C8.51973 3.75 5.71973 6.55 5.71973 10V16C5.71973 18.89 8.06973 21.25 10.9697 21.25C11.3797 21.25 11.7197 21.59 11.7197 22C11.7197 22.41 11.3897 22.75 10.9697 22.75Z",
    fill: "#757575"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaperclip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paperclip.8ee02e18.svg";
export { ForwardRef as ReactComponent };